import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

console.log('Supabase Init:', {
    hasUrl: !!supabaseUrl,
    hasKey: !!supabaseAnonKey,
    urlLength: supabaseUrl ? supabaseUrl.length : 0
});

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('CRITICAL: Missing Supabase Environment Variables within supabase.js');
}

// Prevent crash if keys are missing so we can see the error in console
// Prevent crash if keys are missing so we can see the error in console
let client = null;
try {
    if (supabaseUrl && supabaseAnonKey) {
        client = createClient(supabaseUrl, supabaseAnonKey);
    }
} catch (error) {
    console.error('Supabase Client Creation Failed:', error.message);
}

export const supabase = client;
